import { ConnectionType, type MarketAccountsContextProps } from '@talos/kyoko';
import { compact } from 'lodash-es';
import {
  getTradableMarketAccountNames,
  type GetTradableMarketAccountNamesParams,
} from '../../../hooks/useTradableMarketAccountNames';
import type { MarketSelectorItem } from '../types';
import { buildMarketSelectorItems } from '../utils/useBuildMarketSelectorItems';
import {
  getRFQMarketSelectorConditions,
  type GetRFQMarketSelectorConditionsParams,
} from './getRFQMarketSelectorConditions';

export type GetRFQMarketSelectorItemsParams = Omit<
  GetTradableMarketAccountNamesParams,
  'connectionType' | 'includeOfflineMarkets' | 'combineAllMarketAccounts'
> &
  Omit<GetRFQMarketSelectorConditionsParams, 'ulTokensForSymbol'> & {
    marketAccountsByName: MarketAccountsContextProps['marketAccountsByName'];
  };

export function getRFQMarketSelectorItems({
  marketAccountsByName,
  symbol,
  securitiesBySymbol,
  mssByAccountBySymbol,
  enableMSSValidation,
  marketCredentialsWithConnectionStatusByMarketAccountName,
  careOrderMarkets,
  ...params
}: GetRFQMarketSelectorItemsParams): MarketSelectorItem[] {
  const tradableMarketAccountNames = getTradableMarketAccountNames({
    ...params,
    securitiesBySymbol,
    connectionType: ConnectionType.RFQ,
  });

  const tradableMarketAccounts = compact(tradableMarketAccountNames.map(name => marketAccountsByName.get(name)));

  const conditions = getRFQMarketSelectorConditions({
    careOrderMarkets,
    enableMSSValidation,
    symbol,
    mssByAccountBySymbol,
    securitiesBySymbol,
    marketCredentialsWithConnectionStatusByMarketAccountName,
  });

  return buildMarketSelectorItems({
    marketAccounts: tradableMarketAccounts,
    conditions,
    marketsByName: params.marketsByName,
  });
}
